<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<ng-container *ngIf='!dataLoading'>
  <div mat-dialog-title>
    <h2>{{"forms." + (isUpdate ? 'Update' : 'Add New') | translate}}</h2>
    <button mat-icon-button class="close" (click)="openConfirmDialog()">
      <mat-icon class="pop-close">close</mat-icon>
    </button>
  </div>
  <form [formGroup]="formGroup">
    <mat-dialog-content class="pb-0">
      <div class="mat-dialog-body">
        <div class="fields-group">
          <mat-form-field class="mb-2">
            <mat-label>{{"forms.Category Name" | translate}}</mat-label>
            <input matInput formControlName="title_EN" maxlength="20">
            <mat-error *ngIf="hasError('title_EN', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <!-- <mat-error *ngIf="hasError('title_EN', 'pattern')">
              {{ 'forms.EntervalidNameinEnglish' | translate }}
            </mat-error> -->
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{"forms.Category Name in Arabic" | translate}}</mat-label>
            <input matInput formControlName="title_AR" maxlength="20">
            <mat-error *ngIf="hasError('title_AR', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <!-- <mat-error *ngIf="hasError('title_AR', 'pattern')">
              {{ 'forms.EntervalidNameinArabic' | translate }}
            </mat-error> -->
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
      <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
        {{"forms." + (isUpdate ? 'Update' : 'Add') | translate}}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
